<template>
    <div class="full-height">
        <nested-post-sidebar :key="group.id" :group="group" :sidebarPosts="sidebarPosts" :category="category"/>

        <div id="content-wrapper">
            
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import qs from 'qs';
    export default {
        props: ['group', 'post', 'category'],
        watch: {
            category: {
                deep: true,
                handler(){
                    //this.getPosts();
                }
            }
        },
        computed: {
            ...mapState({
                sidebarPosts: state => state.group.posts,
            })
        },
        data(){
            return {
                posts: []            
            }
        },
        created(){
            this.getPosts();
        },
        methods: {
            getPosts(){
                var queryString = qs.stringify({
                    category: this.category
                });

                axios.get('/api/groups/' + this.group.slug + '/posts?'+ queryString).then((response) => {
                    //this.posts = response.data;
                    this.$store.commit('group/setPosts', response.data);
                    //this.$refs.pagination.setPaginationData(response.data);
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>